export enum UberDirectDeliveryOffsetCalculationMode {
  LEGACY = 'legacy',
  VERSION_JULY_2026 = 'version_july_2026',
}
